import * as React from "react";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import { USAGE_MATCHING_WORKS_SECTION_KEY, USAGE_ROWS_SECTION_KEY, MATCHINGWORKS_KEY, DEFINITE_MATCH, USAGE_MATCHING_PRODUCTS_SECTION_KEY, MATCHINGPRODUCTS_KEY, REPERTOIRE, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY, USAGE_MATCHSTATUS_DEFINITE_MATCH, USAGE_MATCHSTATUS_POTENTIAL_MATCH, USAGE_MATCHSTATUS_NO_MATCH_FOUND, USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY, USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY, USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY, USAGE_GROUP_ATTACHMENTS_SECTION_KEY, EDITABLE_FIELDS_GRID, TITLE_EDITABLE_FIELDS_VIEW, DATA_GRID_TABLE, GENERAL_DATA_EDITABLE_FIELDS, SEARCH_ACTION, USAGE_GROUP_COMMENTS_KEY, USAGE_GROUP_MATCHING_LICENSE_KEY, USAGE_LICENSE_MATCHING, VIEW_COMPONENT_ROLE, ALL_ROLES, USAGE_MATCHSOURCE_MANUAL_MATCH, CONFIGURE_USAGES_DETAILS_ROLE, USAGE_MAINTENANCE_GRID_VIEW } from "../../../Consts";
import { ITableAction } from "../../../types/ITableAction";
import { showModal, hideModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { addMatchLicenseToUsage, addMatchProductToUsage, addMatchWorkToUsage, addUsageDetailsRowData, addUsageDetailsShareIPRow, clearModalSearchResults, expandMatchWorkResult, searchDataChanged, setEditableFields } from "../../../../redux/reducers/RepertoireReducer";
import { updateUsageField } from "../../../../redux/reducers/RepertoireReducer";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IMatchingWorksRowData } from "../../../types/usageTypes/IMatchingWorksRowData";
import { IMatchingProductsRowData } from "../../../types/usageTypes/IMatchingProductsRowData";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IUsageProductDetails } from "../../../types/usageTypes/IUsageProductDetails";
import UsageMaintenanceAttachmentsGridContainer from "./UsageMaintenanceAttachmentsGridContainer";
import { MessageBanner, MessageType } from "../../../components/messageBanner/MessageBanner";
import { IShowFieldSettingViewModalProps } from "../../../components/repertoireModal/RepertoireModal";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { ITreeData } from "../../../types/ITreeData";
import { IUsagePoolState } from "../../../../redux/types/IUsagePoolState";
import UsageMaintenanceDetailsGrid from "./UsageMaintenanceDetailsGrid";
import AllocationSelectionView from "../../../adjustments/components/allocationSelectionView/AllocationSelectionView";
import { UsageAllocationMapper } from "../../../services/usageServices/UsageAllocationMapper";
import UsageMaintenanceMatchingWorksToolbar from "../usageMaintenanceMatchingWorksToolbar/UsageMaintenanceMatchingWorksToolbar";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import { IWorksSearchQuery } from "../../../types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../../types/IWorksSearchResult";
import UsageSearchView from "../../../components/usageComponents/searchView/UsageSearchView";
import { IMatchProductsSearchQuery } from "../../../types/usageTypes/IMatchProductsSearchQuery";
import { IMatchWorksSearchQuery } from "../../../types/usageTypes/IMatchWorksSearchQuery";
import { IUsagesSearchQuery } from "../../../types/usageTypes/IUsagesSearchQuery";
import { IMatchWorksSearchResult } from "../../../types/usageTypes/IMatchWorksSearchResult";
import { IDistributionType } from "../../../types/usageTypes/IDistibutionType";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { SCREEN_SIZE_BIG_ENOUGH_FOR_TWO_SCREENS } from "../usageMaintenancePage/UsageMaintenancePage";
import UsageMaintenanceGridCommentsDataView from "./usageMaintenanceGridCommentsDataView/UsageMaintenanceGridCommentsDataView";
import UsageMaintenanceGridMatchingLicenseView from "./usageMaintenanceGridMatchingLicense/UsageMaintenanceGridMatchingLicenseView";
import { IShoppingCartSearchQuery } from "../../../types/IShoppingCartSearchQuery";
import { ILicenseUsageSearchQuery } from "../../../types/usageTypes/ILicenseUsageSearchQuery";
import { IUsagePoolCore } from "../../../types/usageTypes/IUsagePoolCore";
import ITooltip from "../../../components/Tooltip/IToolTip";
import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import DropDownButtonDefaultView from "../usageSearchToolbar/DropDownButtonDefaultView";
import { IComponentView } from "../../../../redux/types/ComponentView";
import { set } from "lodash";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { IComponentViewReduxStore } from "../../../../redux/types/ComponentViewReduxStore";
import UsageMaintenanceMatchingProductsToolbar from "../usageMaintenanceMatchingProductsToolbar.tsx/UsageMaintenanceMatchingProductsToolbar";
import { IProductSearchResult } from "../../../types/IProductSearchResult";
import { DEFAULT_VIEW_NAME } from "../../../components/modalViews/fieldSettingView/utils/usageResultsFieldUtils";

export interface IUsageMaintenanceGridsViewProps {
    usageMaintenanceGridsViewData: IRepertoireComponentDataItem,
    usageDataGridTableData: IRepertoireComponentDataItem,
    usageGroup: IUsageGroupState
    showModal: typeof showModal;
    clearModalSearchResults: typeof clearModalSearchResults;
    hideModal: typeof hideModal;
    updateUsageField: typeof updateUsageField;
    getWorkDetails: (dataSource: string, workID: number, isOpenedInSecondTab?: boolean) => void;
    getProductDetails: (dataSource: string, tableItem: IMatchingProductsRowData, isOpenedInSecondTab) => void;
    lookupValues?: ILookupDictionary;
    addUsageDetailsShareIPRow?: typeof addUsageDetailsShareIPRow;
    addUsageDetailsRowData?: typeof addUsageDetailsRowData;
    resetMessageBanner: () => void;
    editableFields: IRepertoireField[];
    setEditableFields: typeof setEditableFields;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    sources?: ITreeData[];
    getUsagePool: (poolId: number, matchingSources: ITreeData[]) => void;
    pool?: IUsagePoolState;
    expandedUsageDetailsRow?: number[];
    expandUsageDetail?: (index: number) => void;
    updatedScroll?: number;
    usageMaintenanceMatchingWorksToolbar?: IRepertoireComponentDataItem;
    searchViewData?: IRepertoireComponentDataItem;
    searchViewDataModal?: IRepertoireComponentDataItem;
    searchViewDataMatchingLicense?: IRepertoireComponentDataItem;
    searchResultsTableData?: IRepertoireComponentDataItem;
    dataSource?: string;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    worksSearchResults?: IWorksSearchResult[];
    expandedWorkResults?: number[];
    searchSuccessful?: boolean;
    expandAll?: boolean;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    expandWorkResult?: (workResult: number) => void;
    expandAllResults?: () => void;
    currentPage?: number;
    resetPagination?: (repertoireSection: string) => void;
    updatePagination?: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults?: (name: string, results: any) => void;
    username?: string;
    searchUsages?: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[], continuationToken?: string) => void;
    searchMatchWorks?: (query: IMatchWorksSearchQuery, modalOpen: boolean) => void;
    searchMatchProducts?: (query: IMatchProductsSearchQuery, modalOpen: boolean) => void;
    matchWorkSearchResult?: IMatchWorksSearchResult[];
    matchProductsSearchResult?: IProductSearchResult[];
    expandedMatchWorkResults?: number[];
    distributionTypes?: IDistributionType[];
    lookupSources?: ITreeData[];
    usageMatchingDefaultsWorks?: string[];
    usageMatchingDefaultsProducts?: string[];
    addMatchworkToUsage?: typeof addMatchWorkToUsage;
    addMatchProductToUsage?: typeof addMatchProductToUsage;
    usageExpandAllResults?: () => void;
    expandMatchWorkResult?: (matchWorkResults: number) => void;
    addNewWork: (lookups: ILookupDictionary, actionList?: IDataActionToolbar[], isNew?: boolean, workMaintenanceGeneralDataView?: IRepertoireComponentDataItem, formats?: FormatFields[], workGroupId?: string, workGroup?: string, paneIndex?: number, isFromUsage?: boolean, usage?: IUsageGroupState, isOpenedInSecondTab?: boolean) => void;
    paneIndex?: number;
    formatFields?: FormatFields[];
    updateUsagesAdvanced?: boolean;
    incrementTempID?: () => void;
    enableRegroupAndDeleteUI?:boolean;
    searchLicenses?: (query: ILicenseUsageSearchQuery) => void;
    licensesSearchResults?: any;
    addMatchLicenseToUsage?: typeof addMatchLicenseToUsage;
    setActivePane?: (pane: number) => void;
    settingsModalViewData: IRepertoireComponentDataItem;
    updateComponentViews: (componentViews: any[]) => void;
    getComponentViews: (componentName: string, componentInstance: string) => void;
    componentViews?: IComponentViewReduxStore;
    activeComponentView?: IComponentView;
    usageMaintenanceGridViewsDetailsActiveComponentView?: IComponentView;
    setActiveComponentView?: (activeComponentView: IComponentView) => void;
    roles?: string[];
    userIsConfigureComponentViewAdmin?: boolean;
    componentViewPreference?: IComponentViewsPreference;
    isUsageTabDefaultSetToMatchConfiguration?: boolean;
    openedFrom?: string;
    isValidationWorkFlow?: boolean;
    usageNumberInSearchExclude?: string[];
}

interface IUsageMaintenanceGridsViewState {
    activeHeaderSection: string;
    isExpandedUsageMatchingSection: boolean;
    isExpandedUsageRowsSection: boolean;
    toolbarWidth: number;
    dataAction: IDataActionToolbar[];
    searchCriteriaVisible: boolean;
    expandUsageDetailRowsLocal: number[];
}

export const OPENED_FROM_FINDUSAGE_STRING = 'findUsage';
export const OPENED_FROM_WORKFLOW_STRING = 'workflow';

const UsageMaintenanceGridsView: React.FC<IUsageMaintenanceGridsViewProps> = ({
    usageMaintenanceGridsViewData, 
    searchViewDataModal,
    usageGroup,
    updateUsageField,
    setActivePane,
    paneIndex,
    getWorkDetails,
    getProductDetails,
    showUpdateFieldsModal,
    editableFields,
    usageDataGridTableData,
    setEditableFields,
    editableFieldsDataView,
    updateComponentFieldsItems, 
    tabs, 
    activeTab,
    expandedUsageDetailsRow,
    expandUsageDetail,
    lookupValues,
    searchViewData,
    searchResultsTableData,
    updatedScroll,
    usageMaintenanceMatchingWorksToolbar,
    pool,
    matchWorkSearchResult,
    matchProductsSearchResult,
    resetMessageBanner,
    showModal,
    hideModal,
    clearModalSearchResults,
    addUsageDetailsShareIPRow,
    addUsageDetailsRowData,
    usageMatchingDefaultsWorks,
    searchSuccessful,
    expandMatchWorkResult,
    addMatchworkToUsage,
    addMatchProductToUsage,
    expandedMatchWorkResults, 
    lookupSources,
    distributionTypes,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    resetPagination,
    updatePagination,
    usageExpandAllResults,
    searchUsages,
    searchMatchWorks,
    searchMatchProducts,
    addNewWork,
    formatFields,
    updateUsagesAdvanced,
    incrementTempID,
    enableRegroupAndDeleteUI,
    sortSearchResults,
    searchLicenses,
    licensesSearchResults,
    addMatchLicenseToUsage,
    usageMaintenanceGridViewsDetailsActiveComponentView,
    componentViewPreference,
    setActiveComponentView,
    activeComponentView,
    componentViews,
    searchViewDataMatchingLicense,
    settingsModalViewData,
    roles,
    usageMatchingDefaultsProducts,
    isUsageTabDefaultSetToMatchConfiguration,
    openedFrom,
    isValidationWorkFlow,
    usageNumberInSearchExclude
}) =>{
    const [activeHeaderSection, setActiveHeaderSection] = React.useState<string>(USAGE_ROWS_SECTION_KEY);
    const [isExpandedUsageMatchingSection, setIsExpandedUsageMatchingSection] = React.useState<boolean>(false);
    const [isExpandedUsageRowsSection, setIsExpandedUsageRowsSection] = React.useState<boolean>(false);
    const [toolbarWidth, setToolbarWidth] = React.useState<number>(null);
    const [dataAction, setDataAction] = React.useState<IDataActionToolbar[]>(undefined);
    const [searchCriteriaVisible, setSearchCriteriaVisible] = React.useState<boolean>(false);
    const [expandUsageDetailRowsLocal, setExpandUsageDetailRowsLocal] = React.useState<number[]>([]);
    const [userIsConfigureComponentViewAdmin, setUserIsConfigureComponentViewAdmin] = React.useState(false);
    const [componentViewsForButtonDropDown, setComponentViewsForButtonDropDown] = React.useState<IComponentView[]>([]);
    
    React.useEffect(() => {
        if (!isUsageTabDefaultSetToMatchConfiguration) {
            return;
        }
        if (openedFrom === OPENED_FROM_FINDUSAGE_STRING) {
            if (usageGroup.usageType.toString() === "UsageToWork") {
                setActiveHeaderSection(USAGE_MATCHING_WORKS_SECTION_KEY);
            }
            if (usageGroup.usageType.toString() === "UsageToProduct") {
                setActiveHeaderSection(USAGE_MATCHING_PRODUCTS_SECTION_KEY);
            }
        }
        if (openedFrom === OPENED_FROM_WORKFLOW_STRING) {
            if (isValidationWorkFlow) {
                setActiveHeaderSection(USAGE_ROWS_SECTION_KEY);
            } else {
                if (usageGroup.usageType.toString() === "UsageToWork") {
                    setActiveHeaderSection(USAGE_MATCHING_WORKS_SECTION_KEY);
                }
                if (usageGroup.usageType.toString() === "UsageToProduct") {
                    setActiveHeaderSection(USAGE_MATCHING_PRODUCTS_SECTION_KEY);
                }
            }
        }
    }, [openedFrom, isValidationWorkFlow, isUsageTabDefaultSetToMatchConfiguration, usageGroup?.id, usageGroup?.usageType, usageGroup?.productType]);

    React.useEffect(() => {
        const isMatchStatusNoMatchOrPotential = usageGroup?.matchStatus?.toString() === "No Match Found" || usageGroup?.matchStatus?.toString() === "Potential Match";
        setSearchCriteriaVisible(matchWorkSearchResult || matchProductsSearchResult || isMatchStatusNoMatchOrPotential ? true : false);
        setIsExpandedUsageMatchingSection(true);
    }, [matchWorkSearchResult?.length, matchProductsSearchResult?.length, usageGroup?.matchStatus]);

    React.useEffect(() => {
             if(roles.includes(VIEW_COMPONENT_ROLE) || roles.includes(ALL_ROLES) || roles.includes(CONFIGURE_USAGES_DETAILS_ROLE)) {
                    setUserIsConfigureComponentViewAdmin(true);
                }
    }, [usageGroup]);

    React.useEffect(() => {
        const componentViewsForButtonDropDown = componentViews?.usageMaintenanceGridViewsDetails?.componentViews?.length > 0 ? componentViews.usageMaintenanceGridViewsDetails.componentViews : [];
        setComponentViewsForButtonDropDown(componentViewsForButtonDropDown);
    }, [componentViews]);

   const onClickHeaderSection = (activeHeaderSection: string) => {
    setActiveHeaderSection(activeHeaderSection);
    };

    const renderGridViewHeaderSections = () => {
        if (usageMaintenanceGridsViewData && usageMaintenanceGridsViewData.fields) {
            let filteredFields = usageMaintenanceGridsViewData?.fields?.filter(
                (field: IRepertoireField) =>
                    (usageGroup.usageType.toString() === "UsageToWork"
                        && field.name !== USAGE_MATCHING_PRODUCTS_SECTION_KEY) ||
                    (usageGroup.usageType.toString() === "UsageToProduct"
                        && field.name !== USAGE_MATCHING_WORKS_SECTION_KEY)
            )?.filter(
                (field: IRepertoireField) =>
                    (usageGroup.usageType.toString() === "UsageToWork"
                        && field.name !== USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY) ||
                    (usageGroup.usageType.toString() === "UsageToProduct"
                        && field.name !== USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY)
            )?.filter(
                (field: IRepertoireField) => !(field.name === USAGE_GROUP_MATCHING_LICENSE_KEY &&
                    !(usageGroup.usageType.toString() === "UsageToProduct" && 
                      usageGroup.productType === "SET LIST"))
            )
            
            if (activeComponentView && activeComponentView.fields && activeComponentView.fields.length > 0 && activeComponentView.viewName !== DEFAULT_VIEW_NAME) {
                filteredFields = activeComponentView?.fields?.filter(
                (field: IRepertoireField) =>
                    (usageGroup.usageType.toString() === "UsageToWork"
                        && field.name !== USAGE_MATCHING_PRODUCTS_SECTION_KEY) ||
                    (usageGroup.usageType.toString() === "UsageToProduct"
                        && field.name !== USAGE_MATCHING_WORKS_SECTION_KEY)
            )?.filter(
                (field: IRepertoireField) =>
                    (usageGroup.usageType.toString() === "UsageToWork"
                        && field.name !== USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY) ||
                    (usageGroup.usageType.toString() === "UsageToProduct"
                        && field.name !== USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY)
            )?.filter(
                (field: IRepertoireField) => !(field.name === USAGE_GROUP_MATCHING_LICENSE_KEY &&
                    !(usageGroup.usageType.toString() === "UsageToProduct" && 
                      usageGroup.productType === "SET LIST"))
            )
            }


            return filteredFields.map((section, index) => (
                <div
                    id={`header-section-${section.name}`}
                    className={[
                        "headerSection", activeHeaderSection === section.name ? "activeSection" : null
                    ].join(" ")}
                    key={index}
                    onClick={() => onClickHeaderSection(section.name)}
                >
                    {section.data}
                </div>
            ));
        }
    }

    const getTableActions = (sectionKey: string) => {
        let actions: ITableAction[] = []
        switch (sectionKey) {
            case USAGE_MATCHING_WORKS_SECTION_KEY:
                actions = []
                break;
            case USAGE_MATCHING_PRODUCTS_SECTION_KEY:
                actions = []
                break;
        }
        return actions;
    }

    const changeData = (value: any, name: IRepertoireStateKeys) => {
        if ((name === MATCHINGWORKS_KEY || name === MATCHINGPRODUCTS_KEY)) {
            if (value.length === 1) {
                updateUsageField(USAGE_MATCHSTATUS_DEFINITE_MATCH, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY);
            }
            else if (value.length > 1) {
                updateUsageField(USAGE_MATCHSTATUS_POTENTIAL_MATCH, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY);
            }
            else if (value.length === 0) {
                updateUsageField(USAGE_MATCHSTATUS_NO_MATCH_FOUND, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY);
            }
        }
        updateUsageField(value, name as IRepertoireStateKeys);
    }

    const openWork = (openItem: IMatchingWorksRowData, event?: React.MouseEvent): void => {
        const openInSecondTab = !event?.ctrlKey;
        getWorkDetails(REPERTOIRE, openItem.workID, openInSecondTab);
    }

    const openProduct = (openItem: IMatchingProductsRowData, event?: React.MouseEvent, openInSecondTabDueToOrigin?: boolean): void => {
        const isScreenWidthBigEnoughForTwoScreens = window.innerWidth > SCREEN_SIZE_BIG_ENOUGH_FOR_TWO_SCREENS;
        const openInSecondTab = !event?.ctrlKey && isScreenWidthBigEnoughForTwoScreens || openInSecondTabDueToOrigin;
        getProductDetails(REPERTOIRE, openItem, openInSecondTab);
    }

    const clearAllRowsButThis = (value: any, actionType?: string) => {
        if (actionType) 
            usageGroup.createMatchHistory = actionType === USAGE_MATCHSTATUS_DEFINITE_MATCH;

        if (usageGroup.matchingWorks) {
            const matchingWorks = usageGroup?.matchingWorks?.filter(x => x.workID == value.workID).map((matchingWorks) => {
                matchingWorks.status = USAGE_MATCHSTATUS_DEFINITE_MATCH;
                matchingWorks.source = USAGE_MATCHSOURCE_MANUAL_MATCH;
                return matchingWorks;
            });
            updateUsageField(matchingWorks, MATCHINGWORKS_KEY);

            if (matchingWorks?.filter(x => x.status == USAGE_MATCHSTATUS_DEFINITE_MATCH).length == 1) {
                updateUsageField(USAGE_MATCHSTATUS_DEFINITE_MATCH, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY);
            }
        }
        else {
            const matchingProducts = usageGroup?.matchingProducts?.filter(x => x.productCoreID == value.productCoreID).map((matchingProducts) => {
                matchingProducts.status = USAGE_MATCHSTATUS_DEFINITE_MATCH;
                matchingProducts.source = USAGE_MATCHSOURCE_MANUAL_MATCH;
                return matchingProducts;
            });
            updateUsageField(matchingProducts, MATCHINGPRODUCTS_KEY);

            if (matchingProducts?.filter(x => x.status == USAGE_MATCHSTATUS_DEFINITE_MATCH).length == 1) {
                updateUsageField(USAGE_MATCHSTATUS_DEFINITE_MATCH, MATCHSTATUS_USAGE_MAINTENANCE_STATE_KEY);
            }
        }        
    }

    const showFieldsModal = () => {
        setEditableFields(DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY);

        const fieldsViewData: IRepertoireComponentDataItem = { fields: editableFieldsDataView?.fields?.filter(x => x.componentInstance === GENERAL_DATA_EDITABLE_FIELDS) };
        const title: string = fieldsViewData.fields.find(item => item.name === TITLE_EDITABLE_FIELDS_VIEW).data;
        const fieldSetting: IShowFieldSettingViewModalProps = {
            componentInstance: EDITABLE_FIELDS_GRID,
            componentViewData: fieldsViewData,
            dataGridViewData: usageDataGridTableData,
            onClickSave: onSaveEditableFields,
            key: USAGE_ROWS_SECTION_KEY,
        }

        showUpdateFieldsModal(title, fieldSetting);
    }

    const onSaveEditableFields = () => {
        updateComponentFieldsItems(editableFields["default"], DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY, DATA_GRID_TABLE, tabs, activeTab);
    }

    const onExpandClicked = () => {
        setIsExpandedUsageMatchingSection(!isExpandedUsageMatchingSection);
    }

    const onExpandClickedUsageDetails = () => {
        let newExpandUsageDetailRowLocal = [];
        if(!isExpandedUsageRowsSection){
            usageGroup.usages.map((item, index) => {
                newExpandUsageDetailRowLocal.push(index);
            });
            setExpandUsageDetailRowsLocal(newExpandUsageDetailRowLocal);
        }
        if(isExpandedUsageRowsSection){
            setExpandUsageDetailRowsLocal(newExpandUsageDetailRowLocal);
        }
        setIsExpandedUsageRowsSection(!isExpandedUsageRowsSection);
    }

    const clearExpandedUsageDetailsRow = () => {
        setExpandUsageDetailRowsLocal([]);
    };

    const expandUsageDetailLocal = (index: number) => {
        let newExpandUsageDetailRowLocal = expandUsageDetailRowsLocal;
        if (newExpandUsageDetailRowLocal.includes(index)) {
            newExpandUsageDetailRowLocal = newExpandUsageDetailRowLocal?.filter(item => item !== index);
        } else {
            newExpandUsageDetailRowLocal.push(index);
        }
        setExpandUsageDetailRowsLocal(newExpandUsageDetailRowLocal);
    }
    const renderExpandAll = () => {
        return (
            <div className='arrowIconExpandDiv flexRow'>
                <div className={`paddingRightMedium ${isExpandedUsageMatchingSection ? 'arrowIconExpandAllExpanded' : 'arrowIconExpandAll'}`}>
                    <i className={isExpandedUsageMatchingSection ? "ms-Icon ms-Icon--DoubleChevronUp" : "ms-Icon ms-Icon--DoubleChevronDown"} aria-hidden="true" id="expandResultsButton" onClick={() => onExpandClicked()} title={isExpandedUsageMatchingSection ? "Collapse Results" : "Expand Results"}></i>
                </div>
                {isExpandedUsageMatchingSection ? <div className='arrowIconExpandText'> {"Collapse Results"}</div> : <div className='arrowIconExpandText'> {"Expand Results"}</div>}
            </div>
        );
    }
    
   const renderExpandAllUsageDetails = () => {
        return (
            <div className='arrowIconExpandDiv'>
                <div className={isExpandedUsageRowsSection ? 'arrowIconExpandAllExpanded' : 'arrowIconExpandAll'}>
                    <i className="icon ms-Icon ms-Icon--DoubleChevronLeft" aria-hidden="true" id="expandResultsButton" onClick={() => onExpandClickedUsageDetails()} title={isExpandedUsageRowsSection ? "Collapse Results" : "Expand Results"}></i>
                </div>
                {isExpandedUsageRowsSection ? <div className='arrowIconExpandText'> {"Collapse Results"}</div> : <div className='arrowIconExpandText'> {"Expand Results"}</div>}
            </div>
        );
    }

    const showSearchCriteria = (value: boolean) => {
        setSearchCriteriaVisible(value);
    }


    const renderAccordions = () => {
        let filteredSearchViewData = { fields: [] };
        let searchTypeField;
        let isSearchTypeHidden;
        if (searchViewData) {
            const filtered = searchViewData?.fields?.filter(f => f.componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY);
            searchTypeField = filtered && filtered.find(x => x.name === 'searchType');
            isSearchTypeHidden = searchTypeField && searchTypeField.hidden
            filteredSearchViewData = { fields: searchViewData?.fields?.filter(f => !['usageType', 'searchType'].includes(f.name)) };
        }


        let filteredProductSearchFields = { fields: [] };
        if (searchViewDataModal) {
            filteredProductSearchFields = { fields: searchViewDataModal?.fields?.filter(f => f.componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) };
        }

        switch (activeHeaderSection) {
            case USAGE_ROWS_SECTION_KEY:
                return (
                    <div   id={`${USAGE_ROWS_SECTION_KEY} row section`}>
    
                        <div className="searchResultsDiv">
                            <div className=" flex-end-Content widthFull">
                                        <div className="flexRow flexAlignItemsBaseLine">
                                                        
                                        <div style={{ paddingLeft: "6px", paddingTop: "10px"  }}>
                                            <DropDownButtonDefaultView
                                                isUserAdmin={userIsConfigureComponentViewAdmin}
                                                componentViewPreference={componentViewPreference}
                                                setActiveComponentView={setActiveComponentView}
                                                activeComponentView={usageMaintenanceGridViewsDetailsActiveComponentView}
                                                componentViews={componentViewsForButtonDropDown}
                                                settingsModalViewData={settingsModalViewData}
                                                showFieldsModal={showFieldsModal}
                                                dropDownName={USAGE_MAINTENANCE_GRID_VIEW}
                                            />
                                        </div>
                                    
                                        {userIsConfigureComponentViewAdmin ? <button className="contributorGearBtn" title="Configure data fields"
                                    onClick={showFieldsModal}>
                                <i className="ms-Icon ms-Icon--Settings"></i>
                            </button> : 
                                                <ITooltip
                                                    tooltipContent={'User does not have access'}
                                                    showTooltip={true}
                                                >
                                                <button className="contributorGearBtn" title="Configure data fields"
                                                    disabled={true}
                                                        onClick={showFieldsModal}>
                                                    <i className="ms-Icon ms-Icon--Settings"></i>
                                                </button>
                                                </ITooltip>
                                        }
                                        </div>
                                            </div>
                            {renderExpandAllUsageDetails()}
                            <br/>
                        </div>
                        <UsageMaintenanceDetailsGrid
                            activeComponentView={usageMaintenanceGridViewsDetailsActiveComponentView}
                            dataGridTableData={usageDataGridTableData}
                            tableContents={usageGroup?.usages?.filter(item => item.isDeleted !== true)}
                            isExpandable={true}
                            stateKey={undefined}
                            changeData={changeData}
                            lookupValues={lookupValues}
                            showModal={showModal}
                            addUsageDetailsShareIPRow={addUsageDetailsShareIPRow}
                            addUsageDetailsRowData={addUsageDetailsRowData}
                            resetMessageBanner={resetMessageBanner}
                            pool={usageGroup?.usagePool}
                            expandedUsageDetailsRow={expandUsageDetailRowsLocal}
                            expandUsageDetailRow={expandUsageDetailLocal}
                            clearExpandedUsageDetailsRow={clearExpandedUsageDetailsRow}
                            componentInstance={USAGE_ROWS_SECTION_KEY}
                            updateUsagesAdvanced={updateUsagesAdvanced}
                            enableRegroupAndDeleteUI={enableRegroupAndDeleteUI}
                            expandedUsageMatchingSection={isExpandedUsageRowsSection}
                            usageNumberInSearchExclude={usageNumberInSearchExclude}
                        />
                    </div>)
            case USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY:
                let usageProductDetails: IUsageProductDetails[] = [];
                usageGroup.usages.map(usage =>
                    usage.productDetails.map(pd =>
                        usageProductDetails.push(pd)
                    ));
                return (
                    <DataGridTable
                        dataGridTableData={usageDataGridTableData}
                        componentInstance={USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY}
                        tableContents={usageProductDetails}
                        isExpandable={false}
                        stateKey={undefined}
                        changeData={undefined}
                        showRowNumber={false}
                        sortData={undefined}
                    />
                );
            case USAGE_MATCHING_WORKS_SECTION_KEY:
                let openWorkFlow: boolean;
                function sortByDateDesc(a: any, b: any) {
                    return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
                }

                if (usageGroup.workflows !== null && usageGroup.workflows.length > 0) {
                    usageGroup.workflows.sort(sortByDateDesc);
                    openWorkFlow = usageGroup.workflows[0].entityType === "Usage (Unidentified Performance)" && usageGroup.workflows[0].status === "Open";
                }
                return (
                    <div id={`${USAGE_MATCHING_WORKS_SECTION_KEY}`}>
                        {openWorkFlow ?
                            <div className="row">
                                <MessageBanner
                                    resetMessageBanner={resetMessageBanner}
                                    messageType={MessageType.Danger}
                                    messages={["Outstanding Unidentified Claim Workflow must be processed before this usage group can be matched."]}
                                />
                            </div>
                            : null}
                        {/* <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={this.toolbarParentRef}>
                            </div> */}
                        <div className="row" id={`${USAGE_MATCHING_WORKS_SECTION_KEY} usageMaintenanceMatchingWorksToolbar`}>
                            <div style={{ background: '#f5f5f5', width: '98%', margin: '16px', padding: '7px' }}>
                                <div className="UsageMaintenanceMatchingWorksToolbar">
                                    <UsageMaintenanceMatchingWorksToolbar
                                        scroll={updatedScroll}
                                        toolbarWidth={toolbarWidth}
                                        toolbarData={usageMaintenanceMatchingWorksToolbar}
                                        saveResultData={undefined}
                                        searchWorks={undefined}
                                        resetMessageBanner={undefined}
                                        changesMade={undefined}
                                        usageGroup={usageGroup}
                                        activeTab={undefined}
                                        tabs={undefined}
                                        showModal={showModal}
                                        showYesNoPrompt={undefined}
                                        hideModal={hideModal}
                                        clearModalSearchResults={clearModalSearchResults}
                                        currentUser={undefined}
                                        usageMaintenanceGeneralDataViewData={undefined}
                                        showSearchCriteria={showSearchCriteria}
                                        formatFields={formatFields}
                                        skipWorkWorkflowItem={undefined}
                                        lookupValues={lookupValues}
                                        completeWorkflowOnSave={undefined}
                                        addNewWork={addNewWork}
                                        paneIndex={paneIndex}
                                        componentInstance={USAGE_MATCHING_WORKS_SECTION_KEY}
                                        isSearchCriteriaVisible={searchCriteriaVisible}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" id={`${USAGE_MATCHING_WORKS_SECTION_KEY} usageSearchView`}>
                            {searchCriteriaVisible && <div style={{ margin: '10px' }}>
                                <UsageSearchView
                                    searchViewData={filteredSearchViewData}
                                    searchResultsTableData={searchResultsTableData}
                                    componentInstance={USAGE_MATCHING_WORKS_SECTION_KEY}
                                    modalProps={undefined}
                                    searchUsages={searchUsages}
                                    searchSuccessful={searchSuccessful}
                                    indexOfFirstResult={indexOfFirstResult}
                                    indexOfLastResult={indexOfLastResult}
                                    resultsPerPage={resultsPerPage}
                                    currentPage={currentPage}
                                    resetPagination={resetPagination}
                                    updatePagination={updatePagination}
                                    hideModal={hideModal}
                                    searchMatchWorks={searchMatchWorks}
                                    searchMatchProducts={searchMatchProducts}
                                    matchWorkSearchResult={matchWorkSearchResult}
                                    getUsageDetails={undefined}
                                    expandMatchWorkResult={expandMatchWorkResult}
                                    expandedMatchWorkResults={expandedMatchWorkResults}
                                    addMatchworkToUsage={addMatchworkToUsage}
                                    searchDataChanged={searchDataChanged}
                                    lookupValues={lookupValues}
                                    lookupSources={lookupSources}
                                    distributionTypes={distributionTypes}
                                    usageMatchingDefaultsWorks={usageMatchingDefaultsWorks}
                                    usageExpandAllResults={usageExpandAllResults}
                                    usageGroup={usageGroup}
                                    getWorkDetails={openWork}
                                />
                            </div>}
                            
                            <div className="flexRow paddingLeftMedium positionRelativeTopLarge">
                                {renderExpandAll()}
                            </div>
                            <div className="flexColumn searchResultsDiv">
                            <div className="matchingWorksSection" id={`${USAGE_MATCHING_WORKS_SECTION_KEY} matchingWorksSection`} style={{ margin: '20px' }}>
                                <DataGridTable
                                    dataGridTableData={usageDataGridTableData}
                                    componentInstance={USAGE_MATCHING_WORKS_SECTION_KEY}
                                    tableContents={usageGroup.matchingWorks}
                                    tableActions={getTableActions(USAGE_MATCHING_WORKS_SECTION_KEY)}
                                    showModal={showModal}
                                    clearModalSearchResults={clearModalSearchResults}
                                    stateKey={MATCHINGWORKS_KEY}
                                    hideModal={hideModal}
                                    isExpandable={true}
                                    changeData={changeData}
                                    showRowNumber={false}
                                    sortData={undefined}
                                    usageType={usageGroup.usageType}
                                    openWorkFlow={openWorkFlow}
                                    dependentRowAction={openWork}
                                    clearAllRowsButThis={clearAllRowsButThis}
                                    isExpandedUsageMatchingSection={isExpandedUsageMatchingSection}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                )
            case USAGE_MATCHING_PRODUCTS_SECTION_KEY:
                return (
                    <div className="row" id={`${USAGE_MATCHING_WORKS_SECTION_KEY} usageMaintenanceMatchingWorksToolbar`}>
                            <div style={{ background: '#f5f5f5', width: '98%', margin: '16px', padding: '7px' }}>
                                <div className="UsageMaintenanceMatchingWorksToolbar">
                                    <UsageMaintenanceMatchingProductsToolbar
                                        scroll={updatedScroll}
                                        toolbarWidth={toolbarWidth}
                                        toolbarData={usageMaintenanceMatchingWorksToolbar}
                                        saveResultData={undefined}
                                        searchWorks={undefined}
                                        resetMessageBanner={undefined}
                                        changesMade={undefined}
                                        usageGroup={usageGroup}
                                        activeTab={undefined}
                                        tabs={undefined}
                                        showModal={showModal}
                                        showYesNoPrompt={undefined}
                                        hideModal={hideModal}
                                        clearModalSearchResults={clearModalSearchResults}
                                        currentUser={undefined}
                                        usageMaintenanceGeneralDataViewData={undefined}
                                        showSearchCriteria={showSearchCriteria}
                                        formatFields={formatFields}
                                        skipWorkWorkflowItem={undefined}
                                        lookupValues={lookupValues}
                                        completeWorkflowOnSave={undefined}
                                        paneIndex={paneIndex}
                                        componentInstance={USAGE_MATCHING_PRODUCTS_SECTION_KEY}
                                        isSearchCriteriaVisible={searchCriteriaVisible}
                                    />
                                </div>
                            </div>

                            {searchCriteriaVisible && <div style={{ margin: '10px' }}>
                                
                                <UsageSearchView
                                    searchViewData={filteredProductSearchFields}
                                    searchResultsTableData={searchResultsTableData}
                                    componentInstance={USAGE_MATCHING_PRODUCTS_SECTION_KEY}
                                    modalProps={undefined}
                                    searchUsages={searchUsages}
                                    searchSuccessful={searchSuccessful}
                                    indexOfFirstResult={indexOfFirstResult}
                                    indexOfLastResult={indexOfLastResult}
                                    resultsPerPage={resultsPerPage}
                                    currentPage={currentPage}
                                    resetPagination={resetPagination}
                                    updatePagination={updatePagination}
                                    hideModal={hideModal}
                                    searchMatchWorks={searchMatchWorks}
                                    searchMatchProducts={searchMatchProducts}
                                    matchWorkSearchResult={matchWorkSearchResult}
                                    matchProductsSearchResult={matchProductsSearchResult}
                                    getUsageDetails={undefined}
                                    expandMatchWorkResult={expandMatchWorkResult}
                                    expandedMatchWorkResults={expandedMatchWorkResults}
                                    searchDataChanged={searchDataChanged}
                                    lookupValues={lookupValues}
                                    addMatchProductToUsage={addMatchProductToUsage}
                                    lookupSources={lookupSources}
                                    distributionTypes={distributionTypes}
                                    usageMatchingDefaultsWorks={usageMatchingDefaultsWorks}
                                    usageExpandAllResults={usageExpandAllResults}
                                    usageGroup={usageGroup}
                                    getWorkDetails={openWork}
                                    getProductDetails={openProduct}
                                    usageMatchingDefaultsProducts={[...usageMatchingDefaultsProducts, 'productType']}
                                />
                            </div>}

                    
                            
                            <div className="flexRow paddingLeftMedium positionRelativeTopLarge">
                                {renderExpandAll()}
                            </div>
                            <div className="flexColumn searchResultsDiv">
                        <div id={`${USAGE_MATCHING_PRODUCTS_SECTION_KEY}`}>  
                        <DataGridTable
                            dataGridTableData={usageDataGridTableData}
                            componentInstance={USAGE_MATCHING_PRODUCTS_SECTION_KEY}
                            tableContents={usageGroup.matchingProducts}
                            tableActions={getTableActions(USAGE_MATCHING_PRODUCTS_SECTION_KEY)}
                            showModal={showModal}
                            clearModalSearchResults={clearModalSearchResults}
                            stateKey={MATCHINGPRODUCTS_KEY}
                            hideModal={hideModal}
                            isExpandable={true}
                            changeData={changeData}
                            showRowNumber={false}
                            sortData={undefined}
                            usageType={usageGroup.usageType}
                            dependentRowAction={openProduct}
                            clearAllRowsButThis={clearAllRowsButThis}
                            isExpandedUsageMatchingSection={isExpandedUsageMatchingSection}
                        />
                    </div>
                    </div>
                    </div>
                );
            case USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY:
                return (
                    <div className="row tableContainer" id={`${USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY}`}>
                        <div className={`col-md-12 ${USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY}`}>
                            <AllocationSelectionView
                                searchResults={(usageGroup.allocations ?? []).map((allocation, index) => UsageAllocationMapper.mapAllocationUsageToHeaderRowType(allocation, index))}
                                viewData={usageDataGridTableData}
                                componentInstance={USAGE_GROUP_WORK_ALLOCATIONS_SECTION_KEY}
                            />
                        </div>
                    </div>
                );
            case USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY:
                return (
                    <div className="row tableContainer" id={`${USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY}`}>
                        <div className={`col-md-12 ${USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY}`}>
                            <AllocationSelectionView
                                searchResults={(usageGroup.allocations ?? []).map((allocation, index) => UsageAllocationMapper.mapAllocationUsageToHeaderRowType(allocation, index))}
                                viewData={usageDataGridTableData}
                                componentInstance={USAGE_GROUP_PRODUCT_ALLOCATIONS_SECTION_KEY}
                            />
                        </div>
                    </div>
                );
            case USAGE_GROUP_COMMENTS_KEY:
                return (
                    <UsageMaintenanceGridCommentsDataView
                        usage={usageGroup}
                        isReadonly={false}
                        lookupValues={lookupValues}
                        updateUsageField={changeData}
                        incrementTempID={incrementTempID}
                        dataGridTableData={usageDataGridTableData}
                        showModal={showModal}
                        clearModalSearchResults={clearModalSearchResults}
                        tabs={tabs}
                        activeTab={activeTab}
                    />
                )
            case USAGE_GROUP_MATCHING_LICENSE_KEY:
                    return (
                        <UsageMaintenanceGridMatchingLicenseView
                            searchViewData={searchViewDataMatchingLicense}
                            searchLicenseResultsTableData={searchResultsTableData}
                            isLoading={false}
                            searchSuccessful={searchSuccessful}
                            updatePagination={updatePagination}
                            sortSearchResults={sortSearchResults}
                            hideModal={hideModal}
                            modalProps={undefined}
                            searchLicenses={searchLicenses}
                            licensesSearchResults={licensesSearchResults}
                            usageGroup={usageGroup}
                            addMatchLicenseToUsage={addMatchLicenseToUsage}
                            usageDataGridTableData={usageDataGridTableData}
                            updateUsageField={updateUsageField}
                        />
                    )
            case USAGE_GROUP_ATTACHMENTS_SECTION_KEY:
                return (
                    <UsageMaintenanceAttachmentsGridContainer paneIndex={paneIndex} />
                )
        }
    }


        return (
            <div className="GridsView">
                <div className="headerContainer" id={'headerContainer'}>
                    {renderGridViewHeaderSections()}
                </div>
                {renderAccordions()}
            </div>

        );
}

export default UsageMaintenanceGridsView;